var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-filter"},_vm._l((_vm.options),function(filter,index){return _c('div',{key:("list-filter-item-" + index),staticClass:"list-filter__item",class:{
      'list-filter__item--disabled': _vm.disabled,
      'list-filter__item--selected': JSON.stringify(filter) === JSON.stringify(_vm.selectedFilter),
      'list-filter__item--bigger': _vm.biggerLabel
    },on:{"click":function($event){$event.preventDefault();return _vm.chooseFilter(filter)}}},[_vm._v(" "+_vm._s(filter.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }